
import { Component, Prop, VModel, Vue } from 'vue-property-decorator';
import { IReportContent } from '@/models/application/IReportContent';
import OsInputTextArea from '@/components/core/input/OsInputTextArea.vue';
import {
  FormOfAddress,
  Gender,
  IReportContentCategory,
  ReportType
} from '@/models/application';
import OsButton from '@/components/core/OsButton.vue';
import OsInputCheckbox from '@/components/core/input/OsInputCheckbox.vue';
import OsInputSelect from '@/components/core/input/OsInputSelect.vue';

@Component({
  components: { OsInputSelect, OsInputCheckbox, OsButton, OsInputTextArea }
})
export default class OsReportContentEditor extends Vue {
  @VModel({ type: Array, required: true })
  contents!: IReportContent[];

  @Prop({ type: Array, required: true })
  categories!: IReportContentCategory[];

  @Prop({ type: Boolean, required: false, default: false })
  useCategories!: boolean;

  @Prop({ type: Boolean, required: false, default: false })
  loading!: boolean;

  useSoftWrap = false;
  previewGender = Gender.Male;
  previewFormOfAddress = FormOfAddress.Formal;

  get contentsOrdered(): IReportContent[] {
    return this.contents.sort((c1, c2) =>
      c1.languagecode.localeCompare(c2.languagecode)
    );
  }

  contentsOrderedByCategoryId(categoryId: string): IReportContent[] {
    return this.contents
      .filter((c) => c.categoryId === categoryId)
      .sort((c1, c2) => c1.languagecode.localeCompare(c2.languagecode));
  }

  openPreview(event: {
    content: IReportContent;
    type: ReportType;
    gender: Gender;
    formOfAddress: FormOfAddress;
  }) {
    this.$emit('openPreview', event);
  }

  tab: number | null = 0;
}
